var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('header',[_c('WebHeader',{attrs:{"msg":"WebHeader"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('UserData',{attrs:{"type":"web"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }